import { config } from '@portal/kit/pkg/styles'

// leaving this file here for now for potential overrides

export default config
